"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var _types_1 = require("../../types");
exports.default = (_a = {},
    _a[_types_1.Network.avalanche] = {
        POOL_FACTORY: "0x18aB6357f673696375018f006B86fE44F195DE1f",
    },
    _a[_types_1.Network.avalancheFuji] = {
        POOL_FACTORY: "0x3e4892377B88C216099f16c4f247bC06E48feB67",
    },
    _a);
